<div class="flex flex-col gap-3">
    <p-card>
        <h1>Trip Journals</h1>
    </p-card>
    <div class="grid grid-cols-2 gap-3">

        <p-card class="col-span-2 md:col-span-1">
            <ng-template pTemplate="header">
                <div class="p-card-title">Current Journals</div>
            </ng-template>
            <div class="max-h-[70vh] overflow-y-auto">
                <table class="w-full border">
                    <tbody>
                    @for(trip of currentTrips(); track trip.id) {
                    <tr class=" border-b" [ngClass]="myTripIds().includes(trip.id) ? 'highlight' : ''">
                        <td class="pl-2 py-4">{{trip.id}}</td>
                        <td><a target="_blank" [href]="trip.custId ?? 0 | contactCardUrl:trip.id">{{trip.customerName}}</a>
                        </td>
                        <td>{{trip.tripDate | date}}</td>
                        <td>{{trip.locId | locationDisplay}}</td>
                        <td class="pr-2">
                            <p-button [routerLink]="['/trip-leading/journals/',trip.id]">Open</p-button>
                        </td>
                    </tr>
                    }
                </tbody>
                </table>
            </div>
          
        </p-card>

        <p-card class="col-span-2 md:col-span-1">
            <ng-template pTemplate="header">
                <div class="p-card-title">Recent Journals</div>
            </ng-template>

            <div class="max-h-[70vh] overflow-y-auto">
                <table class="w-full border ">
                    <tbody>
                        @for(trip of recentTrips(); track trip.id) {
                            <tr class="border" [ngClass]="myTripIds().includes(trip.id) ? 'highlight' : ''">
                                <td class="pl-2 py-4">{{trip.id}}</td>
                                <td><a target="_blank" [href]="trip.custId ?? 0 | contactCardUrl:trip.id">{{trip.customerName}}</a>
                                </td>
                                <td>{{trip.tripDate | date}}</td>
                                <td>{{trip.locId | locationDisplay}}</td>
                                <td>
                                    <p-button [routerLink]="['/trip-leading/journals/',trip.id]">Open</p-button>
                                </td>
                            </tr>
                            }
                    </tbody>
                </table>
            </div>

          
        </p-card>
        <p-card class="col-span-2" header="Trip Journal Considerations">
            <div class="grid grid-cols-2 gap-2">
                <div class="col-span-2 md:col-span-1 gap-4">
                    <h2>Instructions</h2>
                    <ol class="list-decimal ps-4 space-y-2">
                        <li>Find the Trip you are journaling for in the table above (your trips should be highlighted).
                        </li>
                        <li> Please make sure all group and trip information is correct and complete.
                            <ul class="list-disc list-inside ps-4">
                                <li>If information is incorrect, please change it or notify your trip leader.</li>
                                <li>If trip information is missing (including local partner, community, or ministries)
                                    please fill in the missing information, or notify your trip leader.</li>
                            </ul>
                        </li>
                        <li>Upload a group photo
                            <ul class="list-disc list-inside ps-4">
                                <li>Please make sure all group member faces can be seen.</li>
                                <li>Find somewhere scenic or ministry related to take your group photo.</li>
                            </ul>
                        </li>
                        <li>Upload a pastor partner photo
                            <ul class="list-disc list-inside ps-4">Please tell the name of the pastor and host church in
                                the post.</ul>
                        </li>
                        <li>Create entries
                            <ul class="list-disc list-inside ps-4">
                                <li>Create your first entry as soon as possible after the group arrives (some trip
                                    leaders even like to make an entry before the group arrives).</li>
                                <li>Include a photo with journal entries.</li>
                                <li>Entries with only a photo still require title, author, and a journal entry.</li>
                            </ul>
                        </li>
                        <li>Edit entries as needed.</li>
                    </ol>
                    <div class="grid grid-cols-3 gap-8 mt-4">
                        <p-panel header="Entry Considerations" class="col-span-3 md:col-span-1">
                            <ol class="list-decimal ps-4 space-y-2">
                                <li>Keep your entries brief when they need to be brief and detailed when they need to be
                                    detailed - allow trip participants the opportunity to tell their own stories when
                                    they get home.</li>
                                <li>Capture powerful moments of partnership and ministry.</li>
                                <li>Use "we" instead of "the group".</li>
                                <li>Avoid writing about issues or emergencies that are taking place.</li>
                            </ol>
                        </p-panel>
                        <p-panel header="Photo Considerations" class="col-span-3 md:col-span-1">
                            <ol class="list-decimal ps-4 space-y-2">
                                <li>No photos of the faces of minors.</li>
                                <li>No photos of faces during ministry involving vulnerable populations (i.e. homeless
                                    ministry, elderly and nursing homes, home visits, etc.)</li>
                                <li>Follow your gut. Does taking a picture feel invasive? Would it make you
                                    uncomfortable if you were photographed in their position? We always prefer that you
                                    do not capture a photo and instead, focus on the ministry, in these situations.</li>
                                <li>Always get consent first and ensure people are aware of the photograph being taken.
                                </li>
                                <li class="font-bold">PPM requires that orphanage visits are a NO PHONE ZONE.</li>
                            </ol>
                        </p-panel>
                        <p-panel header="Video Considerations" class="col-span-3 md:col-span-1">
                            <ol class="list-decimal ps-4 space-y-2">
                                <li>30-60 seconds long</li>
                                <li>Active ministry or participants talking about their trip</li>
                                <li>Upload to YouTube and copy/paste the URL</li>
                            </ol>
                        </p-panel>

                    </div>
                </div>
                <div class="col-span-2 md:col-span-1">
                    <app-youtube-embed class="w-full" styleClass="w-full"
                        youtubeVideoId="PdOAOkRmcn4"></app-youtube-embed>
                </div>
            </div>

        </p-card>
    </div>
</div>